import { ColumnsType } from 'antd/lib/table';
import { Link } from 'react-router-dom';

import DownloadLink from '@okapi/components/DownloadLink';

import { getRawResourceUrl } from './helpers';
import { Resource } from './types';

export const getColumns = (): ColumnsType<Resource> => [
  {
    title: 'Title',
    dataIndex: 'title',
    render: (title: string, { isbn }) => <Link to={`/resources/biliteracy-para-todos/${isbn}`}>{title}</Link>,
    width: 130,
    sorter: (a: { title: string }, b: { title: string }) => a.title.localeCompare(b.title)
  },
  {
    title: 'Type',
    dataIndex: 'type',
    width: 300,
    sorter: (a: { type: string }, b: { type: string }) => a.type.localeCompare(b.type)
  },
  {
    title: 'Stage',
    dataIndex: 'stage',
    width: 200,
    sorter: (a: { stage: string }, b: { stage: string }) => a.stage.localeCompare(b.stage)
  },
  {
    title: 'Actions',
    align: 'right',
    key: 'actions',
    fixed: 'right',
    width: 160,
    render: (_, { asset }) => <DownloadLink url={getRawResourceUrl(asset)} />
  }
];
